<template>
  <div class="ks-painter">
    <transition name="crossfade">
      <div v-if="$root.overlayOpen" class="ks-painter-blur" :class="`ks-painter-blur-${$route.params.route}`"/>
    </transition>
    <canvas ref="painter" id="painter" resize :class="{'canvas-hand': mouseOver === true}"></canvas>
    <div class="controls">
      <div :class="{'blink': customData === false}" v-on:dblclick="customEdit()" v-if="help || customData">{{customData === true ? 'End Custom Mode' : help}}</div>
    </div>
    <div class="controls controls-left" v-if="customData">
      <div v-on:click="exportSVG()">Save</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import paper from 'paper'
import {Howl, Howler} from 'howler'
import { saveAs } from 'file-saver'

const draggableButtons = false;
const fallBack = false;
const volume = 0.25;

const easeOutElastic = function(x){
  const c4 = (2 * Math.PI) / 3;
  return x === 0
    ? 0
    : x === 1
    ? 1
    : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
}

export default {
  name: 'Painter',
  data () {

    return {
      writer: this.convertData(this.$painterdata),
      buttonLineScale: window.innerWidth < 640 ? 1 : 1.5,
      buttons: [
        {line: 0},
        //{line: 4},
        {line: this.calculateBold()},
        //{line: 12},
      ],
      style: {line: 0},
      slant: {
        from: 0,
        to: -45
      },
      font:  '',
      fontsize: this.calculateFontSize(),
      fontcount: 0,
      showbox: false,
      linkitems: [],
      project: false,
      paper: false,
      tool: new paper.Tool(),
      svg: {},
      charActive: false,
      dragActive: false,
      fontLoading: false,
      fontLoadingSteps: 0,
      dragSteps: 0,
      fontLoadcount: 0,
      mouseOver: false,
      resetTimeout: null,
      buttonOverColor: new paper.Color('#ffff99'),
      textShadow: new paper.Color(0, 0, 0, 0.25),
      activeColor: 'black',
      currentFontCount: 3,
      bullets: [],
      corners: [],
      help: " ",
      changefontHelp: 'Serifen verändern',
      changestrokeHelp: 'Strichdicke verändern',
      chars: [],
      gecko: (navigator.userAgent.search(/webkit/i) == -1) && (navigator.userAgent.search(/gecko/i) > 0),
      sound: new Howl({
        src: [require('../assets/sprite.mp3.ogg'), require('../assets/sprite.mp3.mp3')],
        sprite: {
          type: [100, 150],//type: [0, 365.7142857142857],
          load: [2000, 1775],
          bing: [5000, 1332]
        },
        volume: volume
      }),
      hasSoundActive: false,
      customData: false
    } 
  },
  mounted () {
    this.paper            = paper.setup(this.$refs.painter);
    this.paper.settings.hitTolerance = 40;
    this.project          = this.paper.project;
    this.tool.fixedDistance = this.calculateToolStep();

    // draw Buttons
    this.drawButtons(true);

    // draw corners
    this.drawCorners(true);
   
    
    // load svg images
    this.writer.forEach((_w) => {
      if (_w.icon && !this.svg[_w.id]) {
        this.project.importSVG(_w.icon, {
            onLoad: (i, s) => {
              i.fitBounds(new paper.Rectangle(-1000,-1000,this.calculateFontSize(),this.calculateFontSize()));
              if (_w.icon == '/static/images/newsicon.svg') {
                let _t  = new paper.PointText({
                  point: [0,0],
                  content: _w.title,
                  justification: 'center',
                  fillColor: 'white',
                  fontFamily: 'MT',
                  fontSize: 10
                });
                _t.fitBounds(new paper.Rectangle(-1000+this.calculateFontSize()/4,-1000, this.calculateFontSize()*.5,this.calculateFontSize()));
                i.addChild(_t.rotate(45 - Math.random()*90)).bringToFront();
              }
              i.addChild(new paper.Shape.Rectangle({
                point: [-1000,-1000], 
                size: [this.calculateFontSize(),this.calculateFontSize()],
                fillColor: 'rgba(255,255,255,0.01)'
              })).sendToBack();
              this.svg[_w.id] = i;
            },
            insert: true,
            expandShapes: true
        })
      }
    })

    window.addEventListener('resize', () => {
      this.resize()
    });

    this.$root.$on('overlay:scroll', (y) => {
        this.moveElements(y)
    })

    this.$root.$on('overlay:close', (y) => {
        this.removeLink();
        this.$root.hitareaActive = false;
        this.$root.overlayOpen   = false;
    })

    /*this.$root.$on('painter:activate', (e) => {
      setTimeout(()=>{
        this.tool.emit('mousedrag',e)
      }, 1000)
    })*/

    this.font = this.loadFont("dynopunk", {}, ()=>{
      // setup mouse tool
      this.toolSetup();
    })

  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    exportSVG() {
      let svg = this.project.exportSVG({asString: true});

      let stringifyRule = function(rule) {
        return rule.cssText || ''
      }
      let _str = Array.from(this.$root.sheet.cssRules)
        .map(rule => stringifyRule(rule))
        .join('\n')

      svg = svg.replace(/<svg(.*?)>/, (e) => {
        return (`${e}
        <defs>
          <style>
            ${_str}
          </style>
        </defs>`)
      })

			saveAs(new Blob([svg], {type: "image/svg+xml;charset=" + document.characterSet}), 'painter.svg');
    },
    convertData(_d) {
      let _writer = [];
      _d.forEach((_c) => {
        if (_c.word) {
          for(const char of _c.word) {
            let _object = { ..._c };
            _object.letter = char;
            _writer.push(_object)
          }
        }
        if (_c.icon) {
          _writer.push(_c)
        }
        _writer.push({
          space: true,
          route: false,
          color: false
        })      
      })
      return _writer;
    },
    customEdit() {
      if (this.customData === true) {
        alert("Reset to normal state : )")
        this.customData = false;
        this.writer = this.convertData(this.$painterdata);
      }
      else {
        let _customString = prompt('Enter a string to play with').toUpperCase().split(" ");
        let _customData = [];
        _customString.forEach(c => {
          _customData.push({
            'color': 'black',
            'controller': false,
            'route': false,
            'word': c
          })
        })
        this.writer = this.convertData(_customData);
        this.customData = true;
      }
    },
    calculateBold() {
      return (6 / 1440 * window.innerWidth);//_self.tool.minDistance * 3.5,//((Math.abs(step.x) + Math.abs(step.y)) * 2),
      //return (Math.sqrt(window.innerWidth*window.innerHeight)/10);//_self.tool.minDistance * 3.5,//((Math.abs(step.x) + Math.abs(step.y)) * 2),
    },
    calculateFontSize() {
      //return (window.innerWidth/15);//_self.tool.minDistance * 3.5,//((Math.abs(step.x) + Math.abs(step.y)) * 2),
      return (Math.sqrt(window.innerWidth*window.innerHeight)/10);//_self.tool.minDistance * 3.5,//((Math.abs(step.x) + Math.abs(step.y)) * 2),
    },
    calculateToolStep() {
      return this.calculateFontSize() / 2.5;
    },
    removeLink() {
      this.linkitems.forEach((c, ci) => {
        c.remove();
      });
      this.linkitems = [];
    },
    moveElements(y) {
      this.linkitems.forEach(c => {
          let _path = [
            c.bounds.topLeft, 
            c.bounds.bottomLeft,
            c.bounds.bottomRight, 
            c.bounds.topRight
          ];

          let _yValues = [
            _path[0].y, 
            _path[1].y, 
            _path[2].y, 
            _path[3].y
          ].sort((a, b) => {return a - b;});


          if (_yValues[_yValues.length - 1] > y) {
            let _diff = _yValues[_yValues.length - 1] - y
            c.translate({x:0,y: -_diff})
            if (c.children[1].rotation < -5 && c.children[1].rotation > -85) c.rotation++
            else if (c.children[1].rotation < -95) c.rotation--
            else if (c.children[1].rotation > 5 && c.children[1].rotation < 85) c.rotation--
            else if (c.children[1].rotation > 95) c.rotation++
          }
      })
    },
    toolSetup() {
      var _self = this;

      this.tool.onMouseUp = (event) => {
        this.dragActive = false;
        this.resetTimeout = setTimeout(()=>{this.dragSteps = 0}, 4000)
        this.hasSoundActive = true;        
      }

      this.tool.onMouseDown = (event) => {
      }

      this.tool.onMouseDrag = (event) => {
        this.help = false;
        if (this.resetTimeout) {
          clearTimeout(this.resetTimeout);
          this.resetTimeout = null;
        }
        if (this.charActive) return;
        this.dragActive = true;
        var step = event.delta;
        if (!step || !step.x) {
          return;
        }
        if (this.fontLoading) {
          this.fontLoadingSteps++;
          this.bullets.push(
              new paper.Path.RegularPolygon({
                  center: event.lastPoint, 
                  radius: 18,
                  sides: 2+Math.round(this.fontLoadingSteps/5),
                  fillColor: "black",
                  onFrame: function(event) {
                    this.rotate(1);
                  }
                })
          );
          return;
        }
        else this.fontLoadingSteps = 0;

        if (this.hasSoundActive) {
          // this.sound.volume(volume / 100 * (this.dragSteps<100?this.dragSteps:100));
          this.sound.stereo((2 / window.innerWidth * event.point.x) - 1)
          this.sound.play('type');
        }        
        


        var glSize = new paper.Size(Math.abs(step.x) + Math.abs(step.y), Math.abs(step.x) + Math.abs(step.y));
        //var _char_index = event.count % this.sentence.length;  // Restart
        var _char_index = this.dragSteps % this.writer.length; // Always advance

        let _current_action = this.writer[_char_index];

        this.buttons.forEach((b) => {
          if (!b.shape) return;
          if (b.shape.hitTest([event.lastPoint.x, event.lastPoint.y + (glSize.height / 3)]) !== null) {
            if (this.style !== b) {
              this.style = b       
              if (this.hasSoundActive) {       
                this.sound.play('bing');
              }
              if (b.shape.isLine) {
                b.shape.tweenTo(
                        { scaling: 1+Math.random(), shadowBlur: 20, rotation: Math.random()*15},
                        { duration: 500, easing: easeOutElastic}
                    )
                setTimeout(()=>{
                  b.shape.tweenTo(
                      { scaling: 1, shadowBlur: 0, rotation: 0},
                      { duration: 500, easing: easeOutElastic}
                  )
                }, 1000)
              }
              else {
                b.shape.tweenTo(
                        { scaling: 1.25, strokeWidth: 10,  shadowBlur: 20},
                        { duration: 500, easing: easeOutElastic}
                    )
                setTimeout(()=>{
                  b.shape.tweenTo(
                      { scaling: 0.8, strokeWidth: 0,  shadowBlur: 0},
                      { duration: 100, easing: easeOutElastic}
                  )
                }, 1000)
              }
            }
          }
        })
        
        var _current = {};
        if (_current_action.letter) {
          _current = {
            char: _char_index,
            space: {x: window.innerWidth, y: window.innerHeight},
            action: _current_action,
            text: new paper.PointText({
              point: [event.lastPoint.x, event.lastPoint.y + (glSize.height / 3)],
              content: _current_action.letter,
              selected: this.showbox,
              justification: 'center',
              fillColor: _current_action.color ? _current_action.color : 'black',
              fontFamily: _self.font,
              fontSize: _self.fontsize,
              strokeColor: _current_action.color ? _current_action.color : 'black',
              strokeWidth: _self.style.line * _self.buttonLineScale,
              strokeCap: 'butt',
              strokeJoin: 'round',
              shadowColor: _self.textShadow,
              shadowBlur: _self.gecko ? 0 : 20 + (_self.style.line * _self.buttonLineScale),
              shadowOffset: _self.gecko ? 0 : new paper.Point(0, 0),
              onMouseEnter: function(event) {
                  if (_self.dragActive === true || _current_action.route === false) return;
                  _self.mouseOver = true
                  _self.chars.forEach((_c) => {
                    try {
                      if (_c.action.uniqueId == _current_action.uniqueId) {
                        if (_self.gecko) {
                          _c.text.fillColor = _self.textShadow;
                        }
                        else {
                          _c.text.shadowColor =  _current_action.color
                          _c.text.shadowBlur  = 20 + (_self.style.line * _self.buttonLineScale)
                        }
                      }
                    }
                    catch (err) {
                      console.warn(err)
                    }
                  })
              },
              onMouseLeave: function(event) {
                  if (_self.dragActive === true || _current_action.route === false) return;
                  _self.mouseOver = false
                  _self.chars.forEach((_c) => {
                    try {
                      if (_c.action.uniqueId == _current_action.uniqueId) {
                        if (_self.gecko) {
                          _c.text.fillColor = _current_action.color ? _current_action.color : 'black'
                        }
                        else {
                          _c.text.shadowColor = _self.textShadow
                          _c.text.shadowBlur = 0;
                        }
                      }
                    }
                    catch (err) {
                      console.warn(err)
                    }
                  });
              },
              onMouseDown: function(event) {
                if (_self.dragActive === true || _current_action.route === false) return;
                _self.charActive = true;
                _self.chars.forEach((_c) => {
                  try {
                    if (_c.action.uniqueId == _current_action.uniqueId) {
                      _c.text.strokeColor = _c.text.fillColor = _self.activeColor;                      
                    }
                  }
                  catch (err) {
                    console.warn(err)
                  }
                });
              },
              onMouseUp: function(event) {
                if (_self.dragActive === true || _current_action.route === false) return;
                _self.charActive = false;
                let o = false;
                _self.chars.forEach((_c) => {
                  try {
                    if (_c.action.uniqueId == _current_action.uniqueId) {
                          if (o === false) o = _c.action;
                          _c.text.strokeColor = _c.text.fillColor = _c.action.color;
                    }
                  }
                  catch (err) {
                    console.warn(err)
                  }
                });
                return _self.openLink(o);
              }
            })
          };
          _current.bounds = _current.text.bounds;
          _current.text.rotate(step.angle)          
        }
        if (_current_action.icon) {
          _current = {
            char: _char_index,
            space: {x: window.innerWidth, y: window.innerHeight},
            action: _current_action,
            svg: this.svg[_current_action.id].clone().bringToFront()
          }
          _current.svg.rotation = step.angle
          _current.svg.position.x = event.lastPoint.x;
          _current.svg.position.y = event.lastPoint.y - (glSize.height / 2);

          _current.svg.onClick =  (event) => {
              if (_self.dragActive === true || _current_action.route === false) return;
              this.$root.scrollOffset = true;
              this.$router.push({name: _current_action.controller, params: {route: _current_action.route, id: _current_action.id, stub: _current_action.stub}})
              this.linkitems.push(_current.svg)
          }
          _current.svg.onMouseEnter = (event) => {
              if (_self.dragActive === true || _current_action.route === false) return;
              _current.svg.shadowColor  = this.buttonOverColor; 
              _current.svg.shadowBlur   = 10;
              _current.svg.shadowOffset = 0;
              _self.mouseOver = true;
            }
          _current.svg.onMouseLeave = (event) => {
              if (_self.dragActive === true || _current_action.route === false) return;
              _current.svg.shadowColor  = this.buttonOverColor; 
              _current.svg.shadowBlur   = 0;
              _current.svg.shadowOffset = 0;
              _self.mouseOver = true
          }
        }
        if (_current_action.space) {
          _current = {
            action: _current_action
          }
        }        
        var _index = this.chars.push(_current);
        for (let index = _index - this.writer.length - 1; index >= 0; index--) {
            if (this.chars[index]) {
              if (this.chars[index].text) this.chars[index].text.remove();
              if (this.chars[index].svg) this.chars[index].svg.remove();
              delete this.chars[index];
            }
        }
        // push char
        this.dragSteps++;
      }
    },
    drawCorners(anim) {
      let _drawCorners = (x,y, anim) => {
        let _margin_vertical = window.innerWidth / 32;
        let _size = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;
        let _fac = 5;
        let _count = y+(x*2);
        if (this.corners[_count]) {
          this.corners[_count].remove();
          delete this.corners[_count];
        }
        switch (_count) {
          case 0:
            this.corners[_count] = new paper.Shape.Rectangle({
              point: [window.innerWidth / 2 - _size / (_fac * 2), _margin_vertical], 
              size: [_size / _fac, _size / _fac],
              fillColor: 'black',
              applyMatrix: false,
              strokeColor: this.buttonOverColor,
              shadowColor: this.buttonOverColor,
              strokeWidth: 0,
              shadowBlur:  0,
              shadowOffset: 0,
              scaling: anim === true ? 0 : 1
            });
          break;
          case 1:
            this.corners[_count] = new paper.Shape.Circle({
              center: [window.innerWidth / 2, window.innerHeight - _margin_vertical - (_size / (_fac * 2))], 
              radius: _size / (_fac * 2),
              fillColor: 'black',
              applyMatrix: false,
              strokeColor: this.buttonOverColor,
              shadowColor: this.buttonOverColor,
              strokeWidth: 0,
              shadowBlur:  0,
              shadowOffset: 0,
              scaling: anim === true ? 0 : 1
            });
          break;
          case 2:
            /*this.corners[_count] = new paper.Path.RegularPolygon({
              center: [window.innerWidth * x, window.innerHeight * y], 
              radius: window.innerWidth / 8,
              sides: 8,
              applyMatrix: false,
              fillColor: 'black',
              strokeColor: new paper.Color(0, 0, 255),
              shadowColor: new paper.Color(0, 0, 255),
              strokeWidth: 0,
              shadowBlur:  0,
              shadowOffset: 0,
            });*/
          break;
          case 3:
            /*this.corners[_count] = new paper.Shape.Rectangle({
              point: [window.innerWidth * x - window.innerWidth / 16, window.innerHeight * y - window.innerWidth / 16], 
              size: [window.innerWidth / 8, window.innerWidth / 8],
              fillColor: 'white',
              applyMatrix: false
            });*/
          break;
        }
        if (this.corners[_count]) {
          if (anim === true) {
            this.corners[_count].tweenTo(
              { scaling: 1},
              { duration: 1000, easing: easeOutElastic}
            )
          }
          if (draggableButtons) {
            this.corners[_count].onMouseDown = (event) => {
              this.charActive = true;
            }
            this.corners[_count].onMouseUp = (event) => {
              this.charActive = false;
            }
            this.corners[_count].onMouseDrag = (event) => {
              this.corners[_count].position = event.point;
            }
          }
          this.corners[_count].onMouseEnter = (event) => {
            if (this.dragActive && !this.fontLoading) {
              this.font = this.loadFont(`dynopunk-${this.fontcount++}`, {'variant': _count == this.currentFontCount ? 3 : _count});
              this.corners[_count].tweenTo(
                { scaling: 1.25, strokeWidth: 0,  shadowBlur: 20},
                { duration: 500, easing: easeOutElastic}
              )
            }
            this.help_backup = this.help;
            this.help = this.help ? this.changefontHelp : false
          }
          this.corners[_count].onMouseLeave = (event) => {
            this.corners[_count].tweenTo(
                { scaling: 1.0, strokeWidth: 0,  shadowBlur: 0},
                { duration: 500, easing: easeOutElastic}
            )
            this.corners[_count].strokeWidth  = 0;
            this.corners[_count].shadowBlur   = 0;
            this.help = this.help_backup;
          }      
        }
      }
      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 2; y++) {
          if (anim === true) {
            setTimeout(()=>{_drawCorners(x,y,anim)}, 1000*(x+y))
          } else {
            _drawCorners(x,y, anim)
          }
        }      
      }
      
    },
    drawButtons(anim) {
      let _drawButton = (b,bk, anim) => {
        let _margin_horizontal = window.innerWidth / 8;
        let _fac = 5;
        let _height = window.innerHeight / _fac;
        let _width = _height / 4;//(b.line * 5) + 5;
        let _top = window.innerHeight / 2 - (_height / 2);

        let _left = (bk * (window.innerWidth - (_margin_horizontal * 2) - _width)) + _margin_horizontal;


        if (b.shape) {
          b.shape.remove();
          delete b.shape;
        }
        var point = new paper.Point(_left, _top);
        var size  = new paper.Size(_width, _height);

        b.shape = new paper.Path();
        b.shape.add(new paper.Point(_left + _width / 2, _top));
        b.shape.add(new paper.Point(_left, _top + _height / 5));
        b.shape.add(new paper.Point(_left + _width, _top + _height / 5 * 2));
        b.shape.add(new paper.Point(_left, _top + _height / 5 * 3));
        b.shape.add(new paper.Point(_left + _width, _top + _height / 5 * 4));
        b.shape.add(new paper.Point(_left + _width / 2, _top + _height));
        b.shape.smooth();
        b.shape.isLine = true;
        b.shape.applyMatrix = false;
        b.shape.strokeColor = 'black';//this.buttonOverColor;
        b.shape.strokeWidth = b.line * 2 + 2;
        b.shape.strokeCap = 'round';
        b.shape.shadowColor = this.buttonOverColor; 
        b.shape.shadowBlur =  0;
        b.shape.shadowOffset = 0;
        
        if (anim === true) {
          b.shape.tween(
            { scaling: 0.1},
            { scaling: 1},
            { duration: 1000, easing: easeOutElastic}
          )
        }
      
        b.shape.onMouseEnter = (event) => {
            this.help_backup = this.help;
            this.help = this.help ? this.changestrokeHelp : false            
          }
        b.shape.onMouseLeave = (event) => {
            this.help = this.help_backup;
          }
        if (draggableButtons) {
          b.shape.onMouseDown = (event) => {
            this.charActive = true;
          }
          b.shape.onMouseUp = (event) => {
            this.charActive = false;
          }
          b.shape.onMouseDrag = (event) => {
            b.shape.position = event.point;
          }          
        }
      }
      this.buttons.forEach((b, bk) => {
        if (anim === true) {
          setTimeout(()=>{_drawButton(b,bk, anim)}, 500 + (1000*bk))
        } else {
          _drawButton(b,bk, anim)
        }
      })
    },
    resize() {
      this.drawButtons(false);
      this.drawCorners(false);
      this.tool.fixedDistance = this.calculateToolStep();
      let _fs = this.fontsize = this.calculateFontSize();

      this.chars.forEach((_current) => {
        if (_current.text) {
          let _newPos = [
            _current.text.point.x / _current.space.x * window.innerWidth,
            _current.text.point.y / _current.space.y * window.innerHeight
            ]
          _current.text.point = _newPos;
          _current.text.fontSize = _fs;
        }
        if (_current.svg) {
          let _newPos = [
            _current.svg.position.x / _current.space.x * window.innerWidth,
            _current.svg.position.y / _current.space.y * window.innerHeight
            ]
          //
          _current.svg.fitBounds(new paper.Rectangle(0, 0, this.calculateFontSize(),this.calculateFontSize()));
          _current.svg.position = _newPos;


          
        }
        _current.space = {x: window.innerWidth, y: window.innerHeight}
      })
    },
    openLink(a) {
      this.linkitems = [];               // Array of Paper.Groups transformed to SVG Images
      let segments = [];                // Array of Background Squares
      let _scalefactor = 1.1;
      let _rot_diff = 5;                // Rotation Delta after which a new group is started
      let charGroup = 0;
      let backgroundColor = false;
      let _last_rot_bounds = false;
      let _last_char       = false;
      let _self = this;
      let _active_chars = this.chars.filter((e) => {return (e.action.uniqueId == a.uniqueId)})
      this.chars = this.chars.filter((e) => {return (e.action.uniqueId != a.uniqueId)})

      _active_chars.forEach(_c => {
        if (backgroundColor === false) {
          backgroundColor = _c.action.color;
        }
        let _rot_bounds = _c.bounds.scale(_scalefactor)

        // Advance Character Group if no Hit Test
        if ((_last_rot_bounds !== false && _last_char !== false) && (_last_rot_bounds.intersects(_rot_bounds) === false || Math.abs(_c.text.rotation - _last_char.rotation) > _rot_diff)) {
          charGroup++;
        }

        segments[charGroup] = segments[charGroup] || [];
        segments[charGroup].push(
          {
            topLeft: _rot_bounds.topLeft.rotate(_c.text.rotation, _c.text.position), 
            topRight: _rot_bounds.topRight.rotate(_c.text.rotation, _c.text.position), 
            bottomRight: _rot_bounds.bottomRight.rotate(_c.text.rotation, _c.text.position), 
            bottomLeft: _rot_bounds.bottomLeft.rotate(_c.text.rotation, _c.text.position),
            color: _c.action.color
          }
        )

        this.linkitems[charGroup] = this.linkitems[charGroup] || new paper.Group();
        _last_rot_bounds = _rot_bounds;
        _last_char = _c.text;
        _c.text.fillColor = _c.text.strokeColor = "white";

        // Add Character to SVG Link Items
        this.linkitems[charGroup].action = a;
        this.linkitems[charGroup].addChild(_c.text).sendToBack();
        if (fallBack) {
          this.linkitems[charGroup].onFrame = function(event) {
            let _path = [
              this.bounds.topLeft, 
              this.bounds.bottomLeft,
              this.bounds.bottomRight, 
              this.bounds.topRight
            ];

            let _yValues = [
              _path[0].y, 
              _path[1].y, 
              _path[2].y, 
              _path[3].y
            ].sort((a, b) => {return a - b;});
            if (_yValues[_yValues.length - 1] < _self.$root.overlayScrollY) {
              if (!this.speed) this.speed = 0.001;
              this.translate({x: 0, y: this.speed});
              this.speed *= 1.1;
            }
            else {
              this.speed = false;
            }
          }
        }
      });

      // Add Background Squares to linkItems

      segments.forEach((segment, charGroup) => {
        let _path = [
          segment[0].topLeft, 
          segment[0].bottomLeft,
          segment[segment.length - 1].bottomRight, 
          segment[segment.length - 1].topRight
        ];
     

        this.linkitems[charGroup].addChild(
              new paper.Path({
                  segments: _path,
                  fillColor: segment[0].color,
                  closed: true,
              })
        ).sendToBack();
      });
      this.$root.scrollOffset = true;
      this.$root.color = a.color;
      if (a.id && a.stub) {
        this.$router.push({name: a.controller, params: {route: a.route, id: a.id, stub: a.stub}})
      }
      else {
        this.$router.push({name: a.controller, params: {route: a.route}})
      }

    },
    /*remove() {
        this.chars.forEach((c) => {c.text.remove()});
        this.bullets.forEach((b) => {b.remove()});
        this.bullets = [];
        this.chars = [];
    },*/
    clearBullets() {
      this.bullets.forEach((b, bk) => {
        setTimeout(()=>{b.remove()},bk*10);
      });
      this.bullets = [];
    },
    loadFont(description, options, cb) {
      options = options || {}
      cb = cb || function(){};
      this.currentFontCount = options.variant ? options.variant : false;
      this.fontLoading = true;
      if (this.sound && this.hasSoundActive) {
        this.sound.play('load');
      }
      this.$http.get(`https://font.rokfor.ch/punk-regular.woff?&encoding=base64`, { params: options }).then((d) => {
        try {
          let _rule = `@font-face {
            font-family: "${description}";
            font-style: normal;
            font-weight: normal;
            src: url(data:application/x-font-woff;charset=utf-8;base64,${d.data}) format('woff');
          }`;
          this.$root.sheet.insertRule(_rule, this.$root.sheet.cssRules.length);
          this.$nextTick(()=>{
            this.$root.latestFont = description;
            this.fontLoading = false;
            this.fontLoadcount++;
            this.clearBullets();
            cb();
          });
        } catch (e) {
          console.warn(e);
        }
      }).catch((error) => {
        this.fontLoading = false;
        this.clearBullets();
      });
      return description;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.ks-painter {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  @include vh(100);
  transition: all 0.5s;
  &-blur {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      @include vh(100);
      z-index: 2;
      background-color: $ks-dark-grey;
      mix-blend-mode: overlay;
      opacity: 0.25;
      /*
      &-stiftung {
        background-color: $ks-green;
      }      
      &-calls {
        background-color: $ks-blue;
      }
      &-gesuche {
        background-color: $ks-yellow;
      }
      &-kontakt {
        background-color: $ks-dark-grey
      }
      &-projekte {
        background-color: $ks-pink;
      }
      &-news {
          background-color: $ks-dark-grey;
      }    
      */  
  }
  /*
  &-dimmed {
    filter: blur(1rem);
    background: $ks-grey-medium;
  }
  &-hit {
    background: $ks-grey-medium;
  }*/
  canvas {
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      position: fixed;
      cursor: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='128' height='128' viewport='0 0 128 128' style='fill:black;font-size:110px;'><text x='0px' y='80%'>🖊️</text></svg>") 10 110, auto;
  }
  .canvas-hand {
    cursor: pointer;
  }
  .controls {
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 1rem;
    @include mediumfont;
    &-left {
      left: 0px;
      right: auto;
    }
    a {
      cursor: pointer;
      text-decoration: none;
      &.active {
        text-decoration: underline;
      }
    }
    .blink {
       animation: blink 0.2s linear infinite;
       opacity: 0;
       min-width: 1rem;
       min-height: 1rem;
       cursor: pointer;
    }
    @keyframes blink {
      49% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      99% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Painter.vue